function getOptionSwatchImageUrl(input) {
  const label = input.closest('label') || input.closest('.cl-po--swatch-item');
  if (!label) return null;
  const img = label.querySelector('img');
  if (!img) return null;

  const rawSrc = img.currentSrc || img.getAttribute('src') || img.getAttribute('data-src');
  if (!rawSrc) return null;

  return rawSrc.replace(/_(\d+)x(\.[a-z]+)(\?.*)?$/i, '_1200x$2$3');
}

function normalizeMediaFilename(src) {
  if (!src) return null;

  try {
    var resolved = new URL(src, window.location.origin);
    // Extract just the filename from the path — ignoring CDN host and path
    // differences between swatch images (www.fitnessavenue.ca/cdn/shop/files/)
    // and gallery slide images (cdn.shopify.com/s/files/1/{id}/files/).
    var parts = resolved.pathname.split('/');
    var filename = parts[parts.length - 1];
    if (!filename) return null;
    // Strip Shopify underscore size suffixes like _120x144 or _600x.
    return filename.replace(/_(?:\d+x\d+|\d+x)(?=\.[a-z0-9]+)/i, '').toLowerCase();
  } catch (_error) {
    return null;
  }
}

function getImageComparableSource(image) {
  if (!image) return null;

  var directSrc = image.currentSrc || image.getAttribute('src') || image.getAttribute('data-src');
  if (directSrc) return directSrc;

  var srcset = image.getAttribute('srcset') || image.getAttribute('data-srcset');
  if (!srcset) return null;

  var firstCandidate = srcset.split(',')[0];
  if (!firstCandidate) return null;

  return firstCandidate.trim().split(/\s+/)[0] || null;
}

function canSyncSwatchImageToGallery(productPage, newSrc) {
  var gallery = productPage.querySelector('[data-js-product-gallery]');
  if (!gallery) return false;

  var slides = gallery.querySelectorAll('.product-gallery-item');
  if (slides.length <= 1) {
    return true;
  }

  var candidateFilename = normalizeMediaFilename(newSrc);
  if (!candidateFilename) return false;

  var galleryImages = gallery.querySelectorAll('.product-gallery-item .lazy-image img');
  if (!galleryImages.length) return false;

  for (var i = 0; i < galleryImages.length; i += 1) {
    var image = galleryImages[i];
    var slide = image.closest('.product-gallery-item');
    // Skip slides occupied by the live options app canvas renderer and any
    // injected thumbnail fallback images used only for preview repair.
    if (image.matches('[data-thumbnail-preview-fallback="true"]')) continue;
    if (slide && slide.querySelector('.cl-po--preview-wrapper, .cl-po--preview')) continue;
    var imageSrc = getImageComparableSource(image);
    if (normalizeMediaFilename(imageSrc) === candidateFilename) {
      return true;
    }
  }

  return false;
}

function findMatchingGallerySlideIndex(productPage, newSrc) {
  var gallery = productPage.querySelector('[data-js-product-gallery]');
  if (!gallery) return null;

  var candidateFilename = normalizeMediaFilename(newSrc);
  if (!candidateFilename) return null;

  var slides = gallery.querySelectorAll('.product-gallery-item');
  if (!slides.length) return null;

  for (var i = 0; i < slides.length; i += 1) {
    var slide = slides[i];
    // Skip slides occupied by the live options app canvas renderer.
    if (slide.querySelector('.cl-po--preview')) continue;
    var image = slide.querySelector('.lazy-image img');
    if (!image) continue;

    var imageSrc = getImageComparableSource(image);
    if (normalizeMediaFilename(imageSrc) === candidateFilename) {
      return slide.dataset.index || String(i);
    }
  }

  // Fallback: match against thumbnail images, but only when the corresponding
  // gallery slide is not occupied by the live options app canvas renderer.
  var thumbnails = productPage.querySelectorAll('.product-gallery__thumbnails .thumbnail');
  for (var j = 0; j < thumbnails.length; j += 1) {
    var thumbnail = thumbnails[j];
    var thumbIndex = thumbnail.dataset.index || String(j);
    var correspondingSlide = gallery.querySelector('.product-gallery-item[data-index="' + thumbIndex + '"]');
    if (correspondingSlide && correspondingSlide.querySelector('.cl-po--preview')) continue;
    var thumbnailImage = thumbnail.querySelector('img');
    var thumbnailSrc = getImageComparableSource(thumbnailImage);
    if (normalizeMediaFilename(thumbnailSrc) === candidateFilename) {
      return thumbIndex;
    }
  }

  return null;
}

function moveGalleryToSlide(productPage, index) {
  var gallery = productPage.querySelector('[data-js-product-gallery]');
  if (!gallery) return false;

  var slider = gallery.querySelector('css-slider');
  if (!slider || !slider.sliderEnabled || typeof slider.changeSlide !== 'function') {
    return false;
  }

  var normalizedIndex = String(index);
  slider.changeSlide(normalizedIndex);
  return true;
}

function updateMainGalleryImage(productPage, newSrc, altText, newSrcset) {
  var gallery = productPage.querySelector('[data-js-product-gallery]');
  if (!gallery) return;
  var mainImg = gallery.querySelector('.product-gallery-item .lazy-image img');
  if (!mainImg) return;
  mainImg.src = newSrc;
  mainImg.srcset = newSrcset || newSrc;
  if (altText) mainImg.alt = altText;
  var zoom = gallery.querySelector('[data-image-zoom]');
  if (zoom) zoom.setAttribute('data-image', newSrc);
}

var _imgSwapScrollTimer = null;
var _lastDirectSwapTime = 0;
var _lastInteractedOptionInputId = null;
var READY_CHECK_INTERVAL_MS = 200;
var MAX_READY_ATTEMPTS = 50;
var STARTUP_SYNC_INTERVAL_MS = 120;
var MAX_STARTUP_SYNC_ATTEMPTS = 12;

function scrollGalleryToFirstSlide(productPage) {
  var gallery = productPage.querySelector('[data-js-product-gallery]');
  if (!gallery) return;
  var slider = gallery.querySelector('css-slider');
  if (slider && slider.sliderEnabled && typeof slider.changeSlide === 'function') {
    slider.changeSlide(0);
  }
}

function shouldSyncOptionImage(input) {
  if (!input.classList.contains('cl-po--input')) return false;
  if (input.type !== 'radio') return false;
  return /^v_/.test(input.name || '');
}

function isColorOptionInput(input) {
  return /colour|color/i.test(input.name || '');
}

function getCurrentVariantOptionValues(variants) {
  if (!variants || !variants.currentVariant || typeof variants.currentVariant !== 'object') return [];
  var variant = variants.currentVariant;
  var valueSet = new Set();

  if (Array.isArray(variant.options)) {
    variant.options.forEach(function (value) {
      valueSet.add(value);
    });
  }

  ['option1', 'option2', 'option3'].forEach(function (key) {
    if (variant[key]) valueSet.add(variant[key]);
  });

  return Array.from(valueSet)
    .map(function (value) {
      return (value == null ? '' : String(value)).trim().toLowerCase();
    })
    .filter(Boolean);
}

function findSyncCandidateInput(productPage, preferredInput) {
  var scope = productPage || document;

  if (preferredInput instanceof HTMLInputElement
    && preferredInput.matches('.cl-po--input[type="radio"][name^="v_"]')
    && preferredInput.checked
  ) {
    return preferredInput;
  }

  var checkedRadio = scope.querySelector('.cl-po--input[type="radio"][name^="v_"]:checked')
    || document.querySelector('.cl-po--input[type="radio"][name^="v_"]:checked');
  if (checkedRadio) return checkedRadio;

  var variants = scope.querySelector('product-variants[data-main-product-variants]')
    || document.querySelector('product-variants[data-main-product-variants]');
  var selectedValues = getCurrentVariantOptionValues(variants);
  if (!selectedValues.length) return null;

  var radios = Array.prototype.slice.call(scope.querySelectorAll('.cl-po--input[type="radio"][name^="v_"]'));
  if (!radios.length) {
    radios = Array.prototype.slice.call(document.querySelectorAll('.cl-po--input[type="radio"][name^="v_"]'));
  }

  var matching = radios.filter(function (radio) {
    return selectedValues.includes(String(radio.value || '').trim().toLowerCase());
  });
  if (!matching.length) return null;

  var colorMatch = matching.find(function (radio) {
    return /colour|color/i.test(radio.name || '');
  });
  return colorMatch || matching[0];
}

function runWhenLiveOptionsReady(productPage, onReady) {
  var attempts = 0;
  (function check() {
    attempts += 1;
    if (productPage.querySelector('.cl-po--input') || document.querySelector('.cl-po--input')) {
      onReady();
      return;
    }
    if (attempts < MAX_READY_ATTEMPTS) {
      setTimeout(check, READY_CHECK_INTERVAL_MS);
    }
  })();
}

function handleOptionImageSwap(input, isFromPoll, forceSync) {
  if (!(input instanceof HTMLInputElement)) return;
  if (!input.matches('.cl-po--input')) return;
  if (!shouldSyncOptionImage(input)) return;

  var productPage = input.closest('product-page') || document.querySelector('product-page[data-js-product-component]');
  if (!productPage) return;

  if (!forceSync && !input.checked) return;

  _lastInteractedOptionInputId = input.id || null;

  var newSrc = getOptionSwatchImageUrl(input);
  if (!newSrc) return;

  // Only constrain color swatches to existing gallery media in multi-image galleries.
  // Non-color builder options (e.g., accessories/components) may intentionally use
  // preview images that are not part of product media and should still be allowed.
  if (isColorOptionInput(input) && !canSyncSwatchImageToGallery(productPage, newSrc)) return;

  var matchingGalleryIndex = findMatchingGallerySlideIndex(productPage, newSrc);
  if (matchingGalleryIndex !== null && moveGalleryToSlide(productPage, matchingGalleryIndex)) {
    if (!isFromPoll) {
      _lastDirectSwapTime = Date.now();
    }
    return;
  }

  updateMainGalleryImage(productPage, newSrc, input.value);
  scrollGalleryToFirstSlide(productPage);

  if (!isFromPoll) {
    _lastDirectSwapTime = Date.now();
  }

  clearTimeout(_imgSwapScrollTimer);
  _imgSwapScrollTimer = setTimeout(function () {
    scrollGalleryToFirstSlide(productPage);
  }, 800);
}

document.addEventListener('change', function (event) {
  handleOptionImageSwap(event.target);
}, true);

document.addEventListener('input', function (event) {
  handleOptionImageSwap(event.target);
}, true);

document.addEventListener('click', function (event) {
  const swatch = event.target.closest('.cl-po--swatch-item');
  if (!swatch) return;
  const input = swatch.querySelector('input.cl-po--input');
  if (!input) return;
  const inputId = input.id;
  setTimeout(function () {
    const freshInput = inputId ? document.getElementById(inputId) : swatch.querySelector('input.cl-po--input');
    if (freshInput) handleOptionImageSwap(freshInput);
  }, 200);
}, true);

(function () {
  var _prevStates = {};
  var _pollingIntervalId = null;

  function pollRadios() {
    if (Date.now() - _lastDirectSwapTime < 2000) return;

    var productPage = document.querySelector('product-page[data-js-product-component]');
    if (!productPage) return;

    var radios = productPage.querySelectorAll('.cl-po--input[type="radio"]');
    /* c8 ignore start */
    radios.forEach(function (rb) {
      var key = rb.name + '=' + rb.value;
      var wasChecked = _prevStates[key];
      var isChecked = rb.checked;

      if (isChecked && wasChecked !== true) {
        handleOptionImageSwap(rb, true);
      }
      _prevStates[key] = isChecked;
    });
    /* c8 ignore end */
  }

  function ensurePolling() {
    if (_pollingIntervalId) {
      var currentProductPage = document.querySelector('product-page[data-js-product-component]');
      if (currentProductPage && currentProductPage.querySelector('.cl-po--input')) {
        return;
      }
      clearInterval(_pollingIntervalId);
      _pollingIntervalId = null;
      _prevStates = {};
    }
    _pollingIntervalId = setInterval(function () {
      var productPage = document.querySelector('product-page[data-js-product-component]');
      if (!productPage || !productPage.querySelector('.cl-po--input')) {
        clearInterval(_pollingIntervalId);
        _pollingIntervalId = null;
        _prevStates = {};
        return;
      }
      pollRadios();
    }, 300);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var productPage = document.querySelector('product-page[data-js-product-component]');
    if (!productPage) return;
    runWhenLiveOptionsReady(productPage, function () {
      ensurePolling();

      var variants = productPage.querySelector('product-variants[data-main-product-variants]');
      if (variants) {
        variants.addEventListener('VARIANT_CHANGE', function () {
          setTimeout(function () {
            var preferredInput = _lastInteractedOptionInputId
              ? document.getElementById(_lastInteractedOptionInputId)
              : null;
            var variantInput = findSyncCandidateInput(productPage, preferredInput);
            if (variantInput) {
              handleOptionImageSwap(variantInput, true, !variantInput.checked);
            }
          }, 50);
        });
      }

      var startupAttempts = 0;
      (function syncCheckedRadioOnStartup() {
        startupAttempts += 1;
        var startupPreferredInput = _lastInteractedOptionInputId
          ? document.getElementById(_lastInteractedOptionInputId)
          : null;
        var startupInput = findSyncCandidateInput(productPage, startupPreferredInput);
        if (startupInput) {
          handleOptionImageSwap(startupInput, true, !startupInput.checked);
          return;
        }
        if (startupAttempts < MAX_STARTUP_SYNC_ATTEMPTS) {
          setTimeout(syncCheckedRadioOnStartup, STARTUP_SYNC_INTERVAL_MS);
        }
      })();
    });
  });
})();
